import React from 'react';

export const Ingredients = () => {
    return (
        <div>
            Ingredients Page
        </div>
    );
};